export const SET_SITE_THEME = 'SET_SITE_THEME';
